export const POLICY_FORM = 'POLICY_FORM';
